import { EmailTemplate } from "../../types/EmailTemplate";

export const TemplateNewsletter: EmailTemplate = {
  id: "newsletter",
  name: "Newsletter",
  description: "Bulletin d'information avec introduction et jusqu'à 3 articles",
  templateFile: "newsletter",
  previewData: {
    heroImage: "https://via.placeholder.com/600x200/ff8c00/ffffff?text=NEWSLETTER",
    title: "La newsletter IZI LIFE PAY",
    edition: "Édition — Février 2026",
    intro: "Voici les dernières actualités de la communauté IZI LIFE PAY et nos conseils pour vos transferts.",
    article1Title: "Nouveau corridor : Canada → Guinée",
    article1Excerpt: "Envoyez de l'argent vers la Guinée directement depuis votre wallet.",
    article1Url: "https://izilifepay.com",
    article2Title: "5 astuces pour économiser sur les frais",
    article2Excerpt: "Découvrez comment optimiser vos transferts internationaux.",
    article2Url: "https://izilifepay.com/blog",
  },
  fields: [
    { name: "heroImage", label: "Bannière", type: "image", required: false },
    {
      name: "title",
      label: "Titre de la newsletter",
      type: "text",
      required: true,
      defaultValue: "La newsletter IZI LIFE PAY",
    },
    {
      name: "edition",
      label: "Édition / Période",
      type: "text",
      required: false,
      placeholder: "Ex: Édition — Février 2026",
    },
    {
      name: "intro",
      label: "Introduction",
      type: "textarea",
      required: true,
      placeholder: "Message d'introduction...",
    },
    {
      name: "article1Title",
      label: "Article 1 — Titre",
      type: "text",
      required: true,
      placeholder: "Titre du premier article",
    },
    {
      name: "article1Excerpt",
      label: "Article 1 — Résumé",
      type: "textarea",
      required: false,
      placeholder: "Court résumé...",
    },
    {
      name: "article1Url",
      label: "Article 1 — Lien",
      type: "url",
      required: false,
      placeholder: "https://...",
    },
    {
      name: "article2Title",
      label: "Article 2 — Titre",
      type: "text",
      required: false,
      placeholder: "Titre (optionnel)",
    },
    {
      name: "article2Excerpt",
      label: "Article 2 — Résumé",
      type: "textarea",
      required: false,
    },
    {
      name: "article2Url",
      label: "Article 2 — Lien",
      type: "url",
      required: false,
    },
    {
      name: "article3Title",
      label: "Article 3 — Titre",
      type: "text",
      required: false,
    },
    {
      name: "article3Excerpt",
      label: "Article 3 — Résumé",
      type: "textarea",
      required: false,
    },
    {
      name: "article3Url",
      label: "Article 3 — Lien",
      type: "url",
      required: false,
    },
  ],
};
